'use client';

import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbsStructuredData from './BreadcrumbsStructuredData';

type BreadcrumbProps = {
  className?: string;
  style?: React.CSSProperties;
  breadcrumbItems: {
    url?: string;
    name: string;
    onClick?: (index: number) => void;
  }[];
  showCurrent?: boolean;
  includeUrlForLastItem?: boolean;
  hideStructuredData?: boolean;
  baseUrl: string;
};

// https://www.figma.com/design/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?node-id=1499-24052&m=dev
export default function Breadcrumb({
  className,
  style,
  breadcrumbItems,
  showCurrent = true,
  includeUrlForLastItem = false,
  hideStructuredData = false,
  baseUrl
}: BreadcrumbProps) {
  const intl = useIntl();
  const displayBreadcrumbItems = showCurrent ? breadcrumbItems : breadcrumbItems.slice(0, breadcrumbItems.length - 1);

  return (
    <>
      {!hideStructuredData && (
        <BreadcrumbsStructuredData breadcrumbItems={displayBreadcrumbItems} includeUrlForLastItem={includeUrlForLastItem} baseUrl={baseUrl} />
      )}
      <nav {...setDenaliAttribute('Breadcrumb')} aria-label={intl.formatMessage({ defaultMessage: 'Breadcrumb' })}>
        <ul className={className} style={style}>
          {displayBreadcrumbItems.map((item, index, array) => {
            const jsDocIndex = index + 1; //  index is 1-indexed in jsdoc
            const { name, url } = item;
            const key = `${item.name}-${index}`;
            const isLast = array.length - 1 === index;
            const breadcrumbUrl = isLast && !includeUrlForLastItem ? undefined : url;

            return <BreadcrumbItem url={breadcrumbUrl} name={name} index={jsDocIndex} isLast={isLast} key={key} onClick={item?.onClick} />;
          })}
        </ul>
      </nav>
    </>
  );
}
